module.exports = __webpack_public_path__ + "img/gate_cancelled_badge.d06fe74.svg";